const ProblemSection = () => {
  return (
    <section className="w-full bg-[#f3f1ed] py-28">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="max-w-3xl mx-auto mb-20 text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900">
            El costo no está en el consumo
          </h2>

          {/* Subtítulo */}
          <p className="mt-4 text-lg text-slate-600 whitespace-nowrap">
            Dos empresas pueden consumir lo mismo y pagar{" "}
            <span className="mt-4 text-lg text-slate-600 whitespace-nowrap">
              facturas muy distintas
            </span>.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-14">

          {[
            {
              img: "/CARD-1.png",
              title: "Sobrecostos inesperados",
              text: (
                <>
                  La operación no cambia, pero no existe visibilidad sobre cómo{" "}
                  <span className="font-medium text-sergen-700">
                    reducir el costo eléctrico
                  </span>.
                </>
              ),
            },
            {
              img: "/CARD-2.png",
              title: "La hora sí importa",
              text: (
                <>
                  No todo el consumo pesa igual. El{" "}
                  <span className="font-medium text-sergen-700">
                    momento de uso
                  </span>{" "}
                  define el sobrecosto.
                </>
              ),
            },
            {
              img: "/CARD-3.png",
              title: "Falta de control operativo",
              text: (
                <>
                  Sin visibilidad en momentos críticos, la empresa asume{" "}
                  <span className="font-medium text-sergen-700">
                    costos que no ve
                  </span>.
                </>
              ),
            },
          ].map((card, i) => (
            <div key={i} className="relative">
              {/* Sombra inferior */}
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-[80%] h-8 bg-black/15 blur-xl rounded-full" />

              <div className="bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col h-full">
                <div
                  className="h-52 bg-cover bg-center"
                  style={{ backgroundImage: `url('${card.img}')` }}
                />

                <div className="p-8 flex flex-col">
                  <h3 className="text-xl font-semibold text-sergen-700 text-center">
                    {card.title}
                  </h3>

                  <div className="mt-4 min-h-[96px] flex items-start">
                    <p className="text-slate-700 leading-relaxed">
                      {card.text}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
